export var EFormInitialStateActionType = /*#__PURE__*/function (EFormInitialStateActionType) {
  EFormInitialStateActionType["Updated"] = "formInitialState/updated";
  return EFormInitialStateActionType;
}({});